import { createContext } from "react";
import { UserInfo } from "../pages/Users";

export const UserInfoContext = createContext<UserInfo | null>(null);
